"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupLogKinds = void 0;
// represents some event log on a group, like created, joined
exports.GroupLogKinds = {
    Created: "Created",
    Joined: "Joined",
    Left: "Left",
    InterestLevelChanged: "InterestLevelChanged",
    BecameLeader: "BecameLeader",
    UnbecameLeader: "UnbecameLeader",
};
//# sourceMappingURL=GroupLog.js.map